import I18n from 'I18n';
export const FAKE_THREAD_ID = 101;
export function getPreviewTicketListings() {
  const now = Date.now();
  const HOUR = 60 * 60 * 1000;
  const DAY = 24 * HOUR;
  const WEEK = 7 * DAY;
  const MONTH = 30 * DAY;
  const YEAR = 365 * DAY;
  const mockTickets = [{
    subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subject1'),
    content: I18n.text('customer-portal-app.inboxNavPanel.preview.content1'),
    createdate: now - 2 * HOUR,
    status: 'OPEN',
    __requested_by_full_name_or_email: 'Example Name'
  }, {
    subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subject2'),
    content: I18n.text('customer-portal-app.inboxNavPanel.preview.content2'),
    createdate: now - 6 * HOUR,
    status: 'OPEN',
    __requested_by_full_name_or_email: 'Another Name'
  }, {
    subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subject3'),
    content: I18n.text('customer-portal-app.inboxNavPanel.preview.content3'),
    createdate: now - 1 * DAY,
    status: 'OPEN',
    __requested_by_full_name_or_email: 'Example Name'
  }, {
    subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subject4'),
    content: I18n.text('customer-portal-app.inboxNavPanel.preview.content4'),
    createdate: now - 2 * DAY,
    status: 'CLOSED',
    __requested_by_full_name_or_email: 'Another Name'
  }, {
    subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subject5'),
    content: I18n.text('customer-portal-app.inboxNavPanel.preview.content5'),
    createdate: now - 4 * DAY,
    status: 'OPEN',
    __requested_by_full_name_or_email: 'Example Name'
  }, {
    subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subject6'),
    content: I18n.text('customer-portal-app.inboxNavPanel.preview.content6'),
    createdate: now - 1 * WEEK,
    status: 'OPEN',
    __requested_by_full_name_or_email: 'Another Name'
  }, {
    subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subject7'),
    content: I18n.text('customer-portal-app.inboxNavPanel.preview.content7'),
    createdate: now - 2 * WEEK,
    status: 'CLOSED',
    __requested_by_full_name_or_email: 'Example Name'
  }, {
    subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subject8'),
    content: I18n.text('customer-portal-app.inboxNavPanel.preview.content8'),
    createdate: now - 1 * MONTH,
    status: 'CLOSED',
    __requested_by_full_name_or_email: 'Another Name'
  }, {
    subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subject9'),
    content: I18n.text('customer-portal-app.inboxNavPanel.preview.content9'),
    createdate: now - 3 * MONTH,
    status: 'OPEN',
    __requested_by_full_name_or_email: 'Example Name'
  }, {
    subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subject10'),
    content: I18n.text('customer-portal-app.inboxNavPanel.preview.content10'),
    createdate: now - 1 * YEAR,
    status: 'OPEN',
    __requested_by_full_name_or_email: 'Another Name'
  }];
  return {
    total: mockTickets.length,
    hasMore: false,
    offset: 0,
    results: mockTickets.map((ticket, index) => Object.assign({
      hs_ticket_id: index + 1
    }, ticket))
  };
}
export function getPreviewTicketThreads() {
  const now = Date.now();
  const HOUR = 60 * 60 * 1000;
  return {
    threads: [{
      threadId: FAKE_THREAD_ID,
      startedAt: now - 2 * HOUR,
      latestMessageTimestamp: now - 2 * HOUR,
      originalChannel: 'EMAIL'
    }]
  };
}